import { cva } from "class-variance-authority";
import { cn } from "lib/utils";

import "./badge.css";

const badgeVariants = cva("ui-badge", {
  variants: {
    variant: {
      default: "ui-badge-default",
      secondary: "ui-badge-secondary",
      destructive: "ui-badge-destructive",
      outline: "ui-badge-outline",
      ghost: "ui-badge-ghost",
      link: "ui-badge-link",
      critical: "ui-badge-critical",
      info: "ui-badge-info",
      warning: "ui-badge-warning",
      caution: "ui-badge-caution",
      success: "ui-badge-success",
      verified: "ui-badge-success",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

function Badge({ children, className, icon, variant = "default", ...props }) {
  return (
    <div
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant, className }))}
      {...props}
    >
      {icon ? (
        <div className="ui-badge-icon-wrap">
          <div aria-hidden="true" className="ui-badge-icon" data-badge-icon="true">
            {icon}
          </div>
        </div>
      ) : null}
      <div className="ui-badge-label-wrap">
        <div className="ui-badge-label" data-badge-label="true">{children}</div>
      </div>
    </div>
  );
}

export { Badge, badgeVariants };
